import { getFeaturedPlacementByAPI } from '@/api/featuredPlacements';
import {
  ApiCallStatus,
  FeaturedPlacement,
  FeaturedPlacementTypeEnum,
} from '@/types-featured-placement';
import { ReferenceListing } from '@/types-reference-listing';
import { ActionContext } from 'vuex';

export interface FeaturedPlacementState {
  draftPlacement: FeaturedPlacement;
  apiGetCallStatus: ApiCallStatus;
}

const getInitialState = (): FeaturedPlacementState => ({
  draftPlacement: {
    customerId: '',
    type: FeaturedPlacementTypeEnum.BRAND,
  },
  apiGetCallStatus: ApiCallStatus.READY,
});

const mutations = {
  setFeaturedPlacement(state: FeaturedPlacementState, placement: FeaturedPlacement): void {
    state.draftPlacement = placement;
  },
  setFeaturedPlacementType(
    state: FeaturedPlacementState,
    newType: FeaturedPlacementTypeEnum,
  ): void {
    if (state.draftPlacement) {
      state.draftPlacement.type = newType;
    }
  },
  setApiGetCallStatus(state: FeaturedPlacementState, status: ApiCallStatus): void {
    state.apiGetCallStatus = status;
  },
  setHighlightedListings(state: FeaturedPlacementState, listings: ReferenceListing[]): void {
    if (state.draftPlacement) {
      state.draftPlacement.highlightedListings = listings;
    }
  },
};

const getters = {
  getFeaturedPlacement: (state: FeaturedPlacementState): FeaturedPlacement | null =>
    state.draftPlacement,
  getApiGetCallStatus: (state: FeaturedPlacementState): ApiCallStatus => state.apiGetCallStatus,
  getHighlightedListings: (state: FeaturedPlacementState): (ReferenceListing | null)[] =>
    state.draftPlacement.highlightedListings || [null, null, null],
};

const actions = {
  async fetchPlacement(context: ActionContext<FeaturedPlacementState, any>): Promise<void> {
    context.commit('setApiGetCallStatus', ApiCallStatus.IN_PROGRESS);
    try {
      const placement = await getFeaturedPlacementByAPI();
      context.commit('setFeaturedPlacement', placement);
      context.commit('setApiGetCallStatus', ApiCallStatus.SUCCESS);
    } catch (error) {
      context.commit('setApiGetCallStatus', ApiCallStatus.ERROR);
      throw error;
    }
  },
};

const _default = {
  namespaced: true,
  state: getInitialState,
  getters,
  mutations,
  actions,
};
export default _default;
